<template>
  <b-col class="card-hoverable">
    <b-col cols="12" class="m-auto">
      <div class="box-image image m-auto">
        <slot name="p-1" />
      </div>
    </b-col>
    <slot name="p-2" />
    <slot name="p-3" />
  </b-col>
</template>

<script>
export default {
  name: "C516",
};
</script>

<style scoped>
.box-image {
  width: 90px;
  height: 90px;
  margin-top: 20px;
  color: var(--light-red);
  padding: 30px;
  position: relative;
}
.image * {
  position: absolute;
  bottom: 0px;
  left: 10px;
  right: 0px;
  top: 0;
  width: 100%;
  height: auto;
}
.card-hoverable {
  background-image: linear-gradient(
    to bottom,
    var(--light-success) 50%,
    transparent 50%
  );
  background-size: 100% 200%;
  background-position: bottom;
  transition: background-position 0.4s ease-in-out;
  color: var(--black);
  cursor: pointer;
  text-align: center;
  padding: 10px 30px;
  box-shadow: 5px 5px 5px 5px rgb(241, 235, 235);
}
.card-hoverable:hover {
  background-position: top;
}
.card-hoverable:hover > p {
  color: var(--light-white) !important;
  transition: all ease-in-out 0.3s;
}

.card-hoverable:hover > h4 {
  color: var(--light-white) !important;
  transition: all ease-in-out 0.3s;
}

.card-hoverable .image * {
  animation: anim 15s infinite;
  border-radius: 30% 70% 53% 47% / 26% 46% 54% 74%;
}
.card-hoverable:hover > div .box-image {
  color: var(--light-white);
  transition: 0.3s;
  box-shadow: none;
}
@media screen and (max-width: 425px) {
  .card-hoverable .image * {
    height: 90px;
    width: 90px;
    border-radius: 50%;
  }
}
@keyframes anim {
  0%,
  100% {
    border-radius: 30% 70% 70% 30% / 30% 52% 48% 70%;
  }

  10% {
    border-radius: 50% 50% 20% 80% / 25% 80% 20% 75%;
  }

  20% {
    border-radius: 67% 33% 47% 53% / 37% 20% 80% 63%;
  }

  30% {
    border-radius: 39% 61% 47% 53% / 37% 40% 60% 63%;
  }

  40% {
    border-radius: 39% 61% 82% 18% / 74% 40% 60% 26%;
  }

  50% {
    border-radius: 100%;
  }

  60% {
    border-radius: 50% 50% 53% 47% / 72% 69% 31% 28%;
  }

  70% {
    border-radius: 50% 50% 53% 47% / 26% 22% 78% 74%;
  }

  80% {
    border-radius: 50% 50% 53% 47% / 26% 69% 31% 74%;
  }

  90% {
    border-radius: 20% 80% 20% 80% / 20% 80% 20% 80%;
  }
}
</style>
